/**
 * Cryptocurrency display utilities for multi-crypto support
 */

/**
 * Get the appropriate number of decimal places for displaying a cryptocurrency amount
 * @param {string} crypto - The cryptocurrency symbol (e.g., 'BTC', 'PYUSD', 'ETH')
 * @returns {number} Number of decimal places to display
 */
export const getCryptoDecimals = (crypto) => {
  const decimals = {
    'BTC': 8,
    'PYUSD': 6,
    'USDC': 6,
    'USDT': 6,
    'ETH': 8,   // Display precision (not full 18)
    'SOL': 4,
    'LTC': 8,
  };
  return decimals[crypto] || 6;
};

/**
 * Format a crypto amount with the appropriate decimal places
 * @param {number|string} amount - The crypto amount
 * @param {string} crypto - The cryptocurrency symbol
 * @returns {string} Formatted amount string
 */
export const formatCryptoAmount = (amount, crypto) => {
  const decimals = getCryptoDecimals(crypto);
  return parseFloat(amount || 0).toFixed(decimals);
};

export default {
  getCryptoDecimals,
  formatCryptoAmount,
};
